import { MARQUEE_ITEMS } from "@/lib/data";

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section
      className="relative py-8 border-y border-[var(--border-gold)] bg-[var(--surface-subtle)] overflow-hidden"
      data-testid="marquee-section"
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-3xl sm:text-5xl text-[var(--ink)] px-8">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-[var(--gold)]" />
          </span>
        ))}
      </div>
    </section>
  );
}
